import { algoliasearch } from 'algoliasearch';
import algoliasearchHelper from 'algoliasearch-helper';

/** Mirrors `supabase/functions/index-to-algolia/index.ts` defaults. */
const DEFAULT_APP_ID = 'IZI64ZPIU6';
const DEFAULT_INDEX_NAME = 'soperator-ai-docs';

function appId(): string {
  return (import.meta.env.VITE_ALGOLIA_APP_ID as string | undefined)?.trim() || DEFAULT_APP_ID;
}

function indexName(): string {
  return (import.meta.env.VITE_ALGOLIA_INDEX_NAME as string | undefined)?.trim() || DEFAULT_INDEX_NAME;
}

function searchOnlyApiKey(): string | undefined {
  return (
    (import.meta.env.VITE_ALGOLIA_SEARCH_KEY as string | undefined)?.trim() ||
    (import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY as string | undefined)?.trim()
  );
}

export function isAlgoliaSearchConfigured(): boolean {
  return Boolean(searchOnlyApiKey());
}

export interface KbAlgoliaHit {
  objectID: string;
  title?: string;
  tags?: string[];
  state?: string;
  jurisdiction?: string;
  user_id?: string;
}

export type KbAlgoliaSearchHelper = ReturnType<typeof algoliasearchHelper>;

/**
 * Algolia JS client + `algoliasearch-helper` for the KB index (search-only key).
 * Returns `null` when `VITE_ALGOLIA_SEARCH_KEY` is not set.
 */
export function createKbAlgoliaSearchHelper(
  options?: { hitsPerPage?: number },
): KbAlgoliaSearchHelper | null {
  const apiKey = searchOnlyApiKey();
  if (!apiKey) {
    return null;
  }

  const client = algoliasearch(appId(), apiKey);
  return algoliasearchHelper(client, indexName(), {
    hitsPerPage: options?.hitsPerPage ?? 25,
  });
}
